var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "linkContainer"
  }, [_c('ul', [_vm._m(0), _c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'terms'
      }
    }
  }, [_vm._v("Terms")])], 1), _vm._m(1), _c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'privacy'
      }
    }
  }, [_vm._v("Privacy Policy")])], 1)])]), _c('div', {
    staticClass: "copyContainer"
  }, [_vm._v(" © "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("2023 Reach Media Group, Inc")]), _vm._v(" " + _vm._s(new Date().getFullYear()) + ", All rights reserved. ")])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "https://support.reach.me/hc/en-us/requests/new",
      "target": "_blank"
    }
  }, [_vm._v("Contact")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "https://support.reach.me/hc/en-us",
      "target": "_blank"
    }
  }, [_vm._v("Support")])]);
}]

export { render, staticRenderFns }